const filterBrands = (obj) => {
  const popularModels = obj[0].data.items;
  const Brands = obj[1].data.lookupItems;

  /** The response contains duplicates, so we have to just filter them out before displaying them */
  const popular = popularModels
    .map((item) => Brands.filter((brand) => item.vehicleBrand === brand.text));

  const uniq = new Set(popular.map((e) => JSON.stringify(e)));
  const res = [];

  Array.from(uniq).forEach((e) => {
    const item = JSON.parse(e)[0];
    if (item !== undefined) {
      res.push(item);
    }
  });

  return res;
};

export default filterBrands;
